export default "__VITE_PUBLIC_ASSET__9d661215__"